import NextLink from './NextLink';

export default NextLink;
